import { useTranslation } from "@lib/useTypedTranslation";
import { Link } from "react-router-dom";
import { DEFAULT_VALUE, formatDateLastUpdated, formatValue, getFormatNumberToLocale } from "../../../../components/data-table/dataFormatters";
import { ITableColumn } from "../../../../components/data-table/types";
import { useLanguageAndLocaleContext } from "../../../../context/languageAndLocale";
import { useWorldRoutes } from "../../../../routes/parts/allWorldRoutes";
import { IAccessPoint } from "../../../../services/core/accessPoints";

const formatLinkToAccessPoint = (bssid: string, rowData: IAccessPoint, path: string) => {
  if (!bssid) { return DEFAULT_VALUE; }
  return <Link to={`${path}?id=${encodeURIComponent(rowData.id)}`}>{formatValue(bssid)}</Link>;
};

export const useAccessPointsListColumns = () => {
  const { t } = useTranslation('coreAccessPoints');
  const routes = useWorldRoutes();
  const { locale } = useLanguageAndLocaleContext();

  const bssidLinkProcessor = (bssid: string, rowData: IAccessPoint) => {
    return formatLinkToAccessPoint(bssid, rowData, routes.core.accessPointPerformance);
  };

  const columns: ITableColumn[] = [
    { id: 'bssid', title: t('BSSID'), dataPath: 'bssid', sortable: true, processor: bssidLinkProcessor, minWidth: '12rem' },
    { id: 'ssid', title: t('SSID'), dataPath: 'ssid', sortable: true, processor: formatValue, minWidth: '12rem' },
    { id: 'frequency', title: t('FREQUENCY'), dataPath: 'frequency', sortable: true, processor: getFormatNumberToLocale(locale), textAlign: 'right' },
    { id: 'sampleCount', title: t('SAMPLE_COUNT'), dataPath: 'sampleCount', sortable: true, processor: getFormatNumberToLocale(locale), textAlign: 'right' },
    { id: 'score', title: t('SCORE'), dataPath: 'score', sortable: true, processor: getFormatNumberToLocale(locale, 2), textAlign: 'right' },
    { id: 'veryPoorPercentage', title: t('VERY_POOR_PERCENTAGE'), dataPath: 'veryPoorPercentage', sortable: true, processor: getFormatNumberToLocale(locale, 2), textAlign: 'right' },
    { id: 'poorPercentage', title: t('POOR_PERCENTAGE'), dataPath: 'poorPercentage', sortable: true, processor: getFormatNumberToLocale(locale, 2), textAlign: 'right' },
    { id: 'moderatePercentage', title: t('MODERATE_PERCENTAGE'), dataPath: 'moderatePercentage', sortable: true, processor: getFormatNumberToLocale(locale, 2), textAlign: 'right' },
    { id: 'goodPercentage', title: t('GOOD_PERCENTAGE'), dataPath: 'goodPercentage', sortable: true, processor: getFormatNumberToLocale(locale, 2), textAlign: 'right' },
    { id: 'veryGoodPercentage', title: t('VERY_GOOD_PERCENTAGE'), dataPath: 'veryGoodPercentage', sortable: true, processor: getFormatNumberToLocale(locale, 2), textAlign: 'right' },
    { id: 'deviceCount', title: t('UNIQUE_DEVICES'), dataPath: 'deviceCount', sortable: true, processor: getFormatNumberToLocale(locale), textAlign: 'right' },
    { id: 'lastUsed', title: t('LAST_USED'), dataPath: 'lastUsed', sortable: true, processor: formatDateLastUpdated }
  ];

  return columns;
};
